import { useDispatch, useSelector } from "react-redux";
import { addToCart, removeFromCart, updateQuantity } from "../store/features/cartSlice";

/**
 * Кількість товару в кошику і дії з нею — спільне для картки товару й рядка кошика.
 * decrease з кількості 1 прибирає товар з кошика, якщо removeAtZero = true.
 */
const useCartItem = (product, { removeAtZero = true } = {}) => {
  const dispatch = useDispatch();
  const item = useSelector((state) => state.cart.items.find((i) => i.id === product.id));
  const quantity = item?.quantity || 0;

  return {
    quantity,
    add: () => dispatch(addToCart(product)),
    increase: () => dispatch(updateQuantity({ id: product.id, quantity: quantity + 1 })),
    decrease: () => {
      if (quantity > 1) {
        dispatch(updateQuantity({ id: product.id, quantity: quantity - 1 }));
      } else if (removeAtZero) {
        dispatch(removeFromCart({ id: product.id }));
      }
    },
    remove: () => dispatch(removeFromCart({ id: product.id })),
  };
};

export default useCartItem;
